import { HelpCircle } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/lib/utils";

/**
 * Small (i) icon that reveals a short neutral hint on click / focus.
 * Use inline next to a Label or heading. Content is plain text or JSX.
 *
 * <HelpTip id="pattern-days">Pick each weekday…</HelpTip>
 */
export default function HelpTip({
  children,
  id,
  className,
  side = "top",
  align = "start",
  contentClassName,
  label = "More info",
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={label}
          data-testid={id ? `help-tip-${id}` : "help-tip"}
          className={cn(
            "inline-flex items-center justify-center text-slate-400 hover:text-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-300 rounded-full transition",
            className
          )}
        >
          <HelpCircle className="w-3.5 h-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        side={side}
        align={align}
        className={cn(
          "w-72 text-xs leading-relaxed text-slate-700",
          contentClassName
        )}
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        {children}
      </PopoverContent>
    </Popover>
  );
}
